import api from "../api/axiosInstance";

const presenceService = {
  heartbeat: (page, pageLabel) => api.post("/presence/heartbeat", { page, pageLabel }),
  getLive: () => api.get("/presence/live"),
};

export default presenceService;
